import React from 'react'
import { RiArrowRightSLine } from 'react-icons/ri';
import "./contactus.css"
export default function ContactUs() {

  return (
    <div className='emas__contactus'>
        {/* <div className='emas__contactus-header'>
            <h1>Contact Us</h1>
        </div> */}
        <div className='emas__contactus-content'>
            <h1>Contact Us</h1>
            <p>contact@electricitymarketadvisory.com</p>
            <p>0403 227 754</p>  
            <p>ACN 663 507 828</p>    
        </div>
    </div>
  )
}
